import { render, staticRenderFns } from "./wxMachineInfo.vue?vue&type=template&id=383b94ce&scoped=true"
import script from "./wxMachineInfo.vue?vue&type=script&lang=js"
export * from "./wxMachineInfo.vue?vue&type=script&lang=js"
import style0 from "./wxMachineInfo.vue?vue&type=style&index=0&id=383b94ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383b94ce",
  null
  
)

export default component.exports